
export const pricings = {
    data() {
        return {
            mixinData: 'This is mixin data'
        };
    },
    computed:{
        currencySymbol()
        {
            return this.serviceLocale.currency[2]
        },

        additionalFee()
        {
            var app               = this
            var same_day          = false
            app.additional_fee    = false
            app.same_day_upcharge = 0

            if(app.bookForm.selected_date && app.bookForm.selected_hour){

                var dt1 = Date.parse(new Date())
                var date_parse = app.bookForm.selected_date + '-' + app.bookForm.selected_hour
                var a = date_parse.split(/[^0-9]/)
                var dt2=new Date (a[0],a[1]-1,a[2],a[3],a[4],a[5])

                //var dt2 = Date.parse(date_parse.replace(/-/g, "/"))

                if((dt2 - dt1) > 0){

                    app.checkDate(app.bookForm.selected_date)

                }else{
                    // app.$notify.error({
                    //     title  : 'Error',
                    //     message: 'Please select a date/time in the future',
                    //     offset : 100
                    // })
                    app.bookForm.selected_hour = ''
                    return false
                }
            }

            return true
        },


        totalPrice()
        {
            var app = this

            if (app.selected_service) {

                app.bookForm.total_service = 0

                if (app.selected_service.is_hourly) {
                    app.bookForm.total_service = Number(app.selected_service.price) * Number(app.selected_workers_time) * Number(app.selected_workers)
                }else{
                    app.bookForm.total_service = app.selected_service.price
                }

                app.bookForm.total_service =  app.bookForm.total_service || 0

            }



            // Extras Price Calc
            app.bookForm.total_extra = app.bookForm.selected_extras_names.reduce((a, b) => a + (b.quantity * b.price), 0)

            let total = Number(app.bookForm.total_service) + Number(app.bookForm.total_pricing) + Number(app.bookForm.total_extra)



            app.cleaningPrice = total

            total = app.TotalFrequencyDiscount ? (total - app.TotalFrequencyDiscount) : total

            total = app.discountCodeAmount() ? (total - app.discountCodeAmount()) : app.discountCodePercent() ? (total - ( total * app.discountCodePercent()/100 )) : total


            // Giftcard discount calculation
            if(app.gift_card_amount > 0){
                if(total <= app.gift_card_balance)
                    app.gift_card_amount = total
                else
                    app.gift_card_amount = app.gift_card_balance
            }

            total = total - app.gift_card_amount
            // end giftcard discount calculation



            // referrals discount calculation
            if(app.customer){
                if(total <= app.customer.referrals_balance)
                    app.referral_max_amount_to_use = total
                else
                    app.referral_max_amount_to_use = app.customer.referrals_balance

                // If referral balance apply checkbox is enable
                if(app.referral_use_balance){

                    // if amount input is not empty
                    if(typeof app.referral_amount_to_use !== 'undefined'){
                        total = total - app.referral_amount_to_use
                    }

                }
            }
            // end referrals discount calculation



            if(app.additional_fee){

                if(app.feePercent()){

                    let taxFeeValue       = 1 - (Number(app.feePercent())/100)
                    let oldTotal          = total
                    total                 = total/taxFeeValue
                    app.same_day_upcharge = total - oldTotal

                }

                if(app.feeAmount()) {
                    app.same_day_upcharge = app.feeAmount()
                    total += app.same_day_upcharge
                }


            }

            if (app.salesTax != null && app.salesTax.tax_enabled) {
                let taxFeeValue = 1 + (Number(app.salesTax.percentage)/100)
                let oldTotal    = total
                total           = total * taxFeeValue
                app.taxAmount   = total - oldTotal
            }

            return total

        },

        TotalFrequencyDiscount()
        {
            var app     = this
            var amount  = app.discountAmount()
            var percent = app.discountPercent()

            if (app.first_time_client && app.settings.zero_discount_to_first_booking == 1)
            {
                // console.log('is getting here')
                return 0
            }

            if(percent)
                var calc = app.cleaningPrice * (percent / 100)

            return amount? (amount.toFixed(2)) : percent?  ( calc.toFixed(2) )  : 0
        },
    },
    methods: {
        discountAmount()
        {
            if (this.frequency_selected) {
                return Number(this.frequency_selected.amount)
            }

            return 0
        },

        discountPercent()
        {
            if (this.frequency_selected) {
                return Number(this.frequency_selected.percent)
            }

            return 0
        },

        perCleaning()
        {
            return (this.cleaningPrice.toFixed(2) - this.bookForm.total_extra.toFixed(2)).toFixed(2)
        },



        feeAmount()
        {
            if (this.settings) {
                return Number(this.settings.fee_day_amount)
            }

            return 0
        },
        feePercent()
        {
            if (this.settings) {
                return Number(this.settings.fee_day_percent)
            }

            return 0
        },

        discountCodeAmount()
        {
            if (this.selected_discount) {
                return Number(this.selected_discount.amount)
            }

            return 0
        },


        discountCodePercent()
        {
            if (this.selected_discount) {
                return Number(this.selected_discount.percent)
            }

            return 0
        },
    }
};
